import { isJust, Maybe } from '@execonline-inc/structured-maybe';
import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../../../Translations';
import UsersIcon from '../../../../../Cutesies/UsersIcon';
import Modal from '../../../../../Modal';
import ModalStore from '../../../../../Modal/Store';
import { ShareUrlResource } from '../../../../Types';
import LearningCollectionStore from '../../Store';
import Published from './Published';
import ShareUrl from './ShareUrl';

export interface Props {
  name: string;
  shareModalStore: ModalStore;
  publishedAt: Maybe<Date>;
  learningCollectionStore: LearningCollectionStore;
  shareUrlResource: Maybe<ShareUrlResource>;
}

const ShareModal: React.FC<Props> = ({
  name,
  shareModalStore,
  publishedAt,
  shareUrlResource,
  learningCollectionStore,
}) => {
  switch (shareModalStore.state.kind) {
    case 'closed':
      return <></>;
    case 'open':
      return (
        <Modal
          close={shareModalStore.close}
          title={
            <div className="flex items-end px-4 py-6">
              <UsersIcon />
              <h3 className="ml-4 text-xl font-semibold">
                <T kind="Publish and Share" />
              </h3>
            </div>
          }
        >
          <div className="pb-4">
            <p className="text-xl">{name}</p>
            <p className="mt-7 text-base">
              <T kind="Publish <name/> to create a URL..." name={<b>{name}</b>} />
            </p>
            <Published
              publishedAt={publishedAt}
              learningCollectionStore={learningCollectionStore}
            />
            <_ShareUrl shareUrlResource={shareUrlResource} publishedAt={publishedAt} />
          </div>
        </Modal>
      );
  }
};

const _ShareUrl = observer(
  ({ shareUrlResource, publishedAt }: Pick<Props, 'shareUrlResource' | 'publishedAt'>) => {
    return isJust(publishedAt) ? <ShareUrl shareUrlResource={shareUrlResource} /> : <></>;
  },
);

export default observer(ShareModal);
